(function () {
    'use strict';

    angular
        .module('app')
        .factory('uploadFactory', uploadFactory);

    uploadFactory.$inject = ['$http', '$q'];

    function uploadFactory($http, $q) {
        var itemCollection = [];
        // Need to turn itemCollection into an array of objects

        var service = {
            sendEmailNotification: sendEmailNotification,
            addToCollection: addToCollection,
            removeFromCollection: removeFromCollection,
            existsInCollection: existsInCollection,
            removeAllFromCollection: removeAllFromCollection,
            getLength: getLength
        };

        return service;

        function addToCollection(fileName, success, errorMessage) {

            var item = {
                'FileName': fileName,
                'Success': success,
                'ErrorMessage' : errorMessage
            };

            itemCollection.push(item);
        }
        function removeFromCollection(fileName) {
            var ii = itemCollection.length;
            while (ii-- > 0) {
                if (itemCollection[ii]['FileName'] == fileName) {
                    itemCollection[ii]['FileName'] = null;
                    break;
                }
            }
        }
        function existsInCollection(fileName) {
            if (itemCollection[fileName] == null) {
                return false;
            }
            return true;
        }
        function removeAllFromCollection()
        {
            itemCollection.splice(0, itemCollection.length);
        }
        function getLength()
        {
            return itemCollection.length;
        }

        function sendEmailNotification() {

            var deferred = $q.defer();

            //Makes http request
            var request = $http({
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                },
                method: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                crossDomain: true,
                cache: false,
                url: '../Synergis.WebApi/api/CheckIn/UploadEmailNotification',
                data: { '': itemCollection }
            }).then(function (response, status, headers, cfg) {
                // All good.
                console.info('UploadEmailNotification sucess', response);
                removeAllFromCollection();
            }, function (err, status) {
                console.info('UploadEmailNotification error', err, status);
                deferred.reject(err);
            });

            return deferred.promise;
        }
    }
})();